var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWarningTriangle = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.7858 12.0513C34.1018 7.98291 37.9013 7.98291 40.2174 12.0513L48.391 26.4149C50.7129 30.4893 54.5066 37.1528 56.8227 41.2272L64.9963 55.5908C67.3182 59.6653 65.4712 63 60.9036 63H44.3101C39.7366 63 32.2607 63 27.6872 63H11.0995C6.52605 63 4.68493 59.6653 7.00099 55.5908L15.1746 41.2272C17.4965 37.1528 21.2902 30.4893 23.6063 26.4149L31.7858 12.0513Z",
    fill: "#DA1F3D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9981 50C34.3405 50 33 51.3442 33 52.9981C33 54.6558 34.3405 56 35.9981 56C37.6558 56 39 54.6558 39 52.9981C39 51.3442 37.6558 50 35.9981 50Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.75 44.825L33 25.175C33 23.9802 33.7892 23 34.7558 23H37.2404C38.207 23 39 23.9802 39 25.175L38.25 44.825C38.25 46.0245 36.9666 47 36 47C35.0334 47 33.75 46.0245 33.75 44.825Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgWarningTriangle);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/warning-triangle.d28192b41856fce5c82947a8bb53bb24.svg";